import React from 'react'
import { createRoot } from 'react-dom/client'
import '@mriqbox/ui-kit/dist/style.css'
import './styles.css'
import { App } from './App'

createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)

/**
 * Service worker: e ele que torna o app instalavel (ver web/public/sw.js).
 *
 * So em producao. Em dev o Vite serve os modulos por HMR, e um service worker
 * no meio do caminho e fonte classica de "salvei o arquivo e a tela nao mudou".
 *
 * Depois do `load` pra nao disputar banda com o proprio front no primeiro
 * carregamento, e sem `await`: instalar o app nunca pode atrasar entrar na sala.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        void navigator.serviceWorker.register('/sw.js').catch(() => {
            // Sem service worker o site funciona igual — so nao se instala.
        })
    })
}
